<template>
  <CompanyWrapper>
    <CommonHowToJoin></CommonHowToJoin>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import CommonHowToJoin from "../../../../components/pc/howtojoin/CommonHowToJoin";
export default {
  components: {
    CompanyWrapper,
    CommonHowToJoin,
  },
  name: "HowToJoin",
};
</script>



// WEBPACK FOOTER //
// src/pages/pc/company/howtojoin/HowToJoin.vue